
const TeamInfo = [
    {
        id: 1,
        name: "Prof. Manish Joglekar",
        por: "Faculty Advisor",
        url: require("../assets/joglekar.png")
    },
    {
        id: 2,
        name: "Prof. Vidit Gaur",
        por: "Faculty Advisor",
        url: require("../assets/viditgaur.png")
    },
    {
        id: 3,
        name: "Shashank Sawarn",
        por: "Chairperson",
        url: require("../assets/shashank.png")
    },
    {
        id: 4,
        name: "Vaibhav Saini",
        por: "Vice-Chairperson",
        url: require("../assets/saini.png")
    },
    {
        id: 5,
        name: "Mendapara Dhaval",
        por: "Vice-Chairperson",
        url: require("../assets/dhaval.png")
    },
    {
        id: 6,
        name: "Aarjaviy",
        por: "Vice-Chairperson",
        url: require("../assets/aarjaviy.png")
    },
    {
        id: 7,
        name: "Apoorv Gupta",
        por: "Joint-Secretary",
        url: require("../assets/apoorv.png")
    },
    {
        id: 8,
        name: "Arpan Goel",
        por: "Secretary",
        url: require("../assets/arpan.png")
    },
    {
        id: 9,
        name: "Vaibhav Singh",
        por: "Joint-Secretary",
        url: require("../assets/vaibhav.png")
    },
];

export default TeamInfo